<template>
  <div class="how-it-works-wrapper">
    <div class="how-it-works-header">
      {{ t('header') }}
    </div>
    <div class="how-it-works-text">
      {{ t('text') }}
    </div>
    <div class="how-it-works-text icon-wrapper">
      <v-icon class="icon"> mdi-web</v-icon>
      <div v-html="t('multilanguage')"></div>
    </div>
    <div class="how-it-works-text" v-html="t('learn_more')"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HowItWorkShare',
  components: {},
  methods: {
    t(key: string) {
      return this.$t(`HowItWorkShare.${key}`)
    },
  },
})
</script>

<style lang="scss" scoped>
@import '~vuetify/settings';

hr {
  opacity: 0.2;
  margin-top: 14px;
}

.how-it-works-wrapper {
  background: #f9f9f9;
  border-radius: 5px;
  padding: 24px;
  box-shadow: 1px -1px 10px -1px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 1px -1px 10px -1px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 1px -1px 10px -1px rgba(0, 0, 0, 0.1);

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    padding: 16px;
  }
}

.how-it-works-header {
  color: #212121;
  font-size: 28px;
  line-height: 48px;
  font-weight: 600;
}

.how-it-works-text {
  color: #212121;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  margin-top: 16px;
}

.how-it-works-subheader {
  color: #212121;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 34px;
  margin-bottom: 16px;
  margin-top: 30px;
}

.number-explanation-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}

.number {
  background: #f2ebdb;
  border-radius: 50%;
  width: 30px;
  min-width: 30px;
  height: 30px;
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #212121;
  margin-right: 8px;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
}

.explanation {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
}

.icon-wrapper {
  display: flex;
}

.icon {
  margin-right: 16px;
}
</style>
